.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-10) var(--space-6);
  border: 1px dashed var(--color-border-strong);
  border-radius: var(--radius-lg);
  text-align: center;
}

.icon {
  color: var(--color-fg-subtle);
}

.icon svg {
  width: var(--space-8);
  height: var(--space-8);
}

.title {
  font-size: var(--text-md);
  line-height: var(--lh-md);
}

.description {
  max-width: var(--size-measure);
  color: var(--color-fg-muted);
}
